import { LoadingSpinner } from '@cfs-fixings/shared'
import { DesignResource } from '@/api/serverApi'
import UngroupedDesignListView from './views/UngroupedDesignListView'
import UngroupedDesignGridView from './views/UngroupedDesignGridView'

type PropTypes = {
  designs?: DesignResource[]
  footerElements?: React.ReactNode[]
  viewType?: 'list' | 'grid'
  isLoading?: boolean
  dropdown?: (design: DesignResource) => React.ReactNode
}

function BrowseUngroupedDesignsView ({ designs, footerElements, viewType = 'list', isLoading = false, dropdown }: PropTypes) {
  return (
    <div className="w-full">
      {
        viewType === 'list'
          ? (
            <UngroupedDesignListView
              designs={designs}
              footerElements={footerElements}
              dropdown={dropdown}
            />
          )
          : (
            <div className="px-1">
              <UngroupedDesignGridView
                designs={designs}
                footerElements={footerElements}
                dropdown={dropdown}
              />
            </div>
          )
      }
      {
        isLoading
          ? <div className="w-full flex items-center justify-center pt-2">
            <LoadingSpinner className="h-4 w-4" />
          </div>
          : null
      }
    </div>
  )
}

export default BrowseUngroupedDesignsView
